import { Switch } from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import React, { FormEvent } from 'react'
import { useToggleRefinement } from 'react-instantsearch'

import styles from './InstrumentalFilter.module.css'

const InstrumentalFilter = (): JSX.Element => {
	const { t } = useTranslation(['search'])

	const { value, refine } = useToggleRefinement({ attribute: 'Instrumental' })
	const { refine: vocalRefine } = useToggleRefinement({ attribute: 'Vocal' })

	const toggleInstrumental = (event: FormEvent): void => {
		refine({ isRefined: !(event.target as HTMLInputElement).checked })
		if ((event.target as HTMLInputElement).checked === true) {
			vocalRefine({
				isRefined: true,
			})
		}
	}
	return (
		<Switch
			checked={value.isRefined}
			className={styles.switch}
			data-testid="instrumental-switch"
			label={t('instrumental')}
			onChange={toggleInstrumental}
		/>
	)
}

export default InstrumentalFilter
